<template>
    <div class="ds-schedule-stat-bar">
        <div class="ds-schedule-stat-bar-content">
        <div class="ds-schedule-stat-bar-item ds-schedule-stat-bar-item-danger">
            <icon width="16" height="13" class="ds-schedule-stat-bar-icon">
                <IconWarning />
            </icon>
            <span class="ds-schedule-stat-bar-label">Нарушения:</span>
            <span class="ds-schedule-stat-bar-value">{{ warning }}</span>
        </div>
        <div class="ds-schedule-stat-bar-item ds-schedule-stat-bar-item-warning">
            <icon width="16" height="13" class="ds-schedule-stat-bar-icon">
                <IconWarning />
            </icon>
            <span class="ds-schedule-stat-bar-label">Предупрежения:</span>
            <span class="ds-schedule-stat-bar-value">{{ moderate }}</span>
        </div>

        <div class="ds-schedule-stat-bar-item">
            <icon width="16" height="16" class="ds-schedule-stat-bar-icon">
                <IconTime />
            </icon>
            <span class="ds-schedule-stat-bar-label">Плановые часы (осн.):</span>
            <span class="ds-schedule-stat-bar-value">{{ formatHours(planHours) }}</span>
        </div>
        <div class="ds-schedule-stat-bar-item">
            <icon width="16" height="16" class="ds-schedule-stat-bar-icon">
                <IconTime />
            </icon>
            <span class="ds-schedule-stat-bar-label">Дополнительные часы:</span>
            <span class="ds-schedule-stat-bar-value">{{ formatHours(additionHours) }}</span>
        </div>
        <div class="ds-schedule-stat-bar-item">
            <icon width="16" height="16" class="ds-schedule-stat-bar-icon">
                <IconTime />
            </icon>
            <span class="ds-schedule-stat-bar-label">Фактические часы:</span>
            <span class="ds-schedule-stat-bar-value">{{ factHours }}</span>
        </div>
        <div class="ds-schedule-stat-bar-item" v-if="hoursLimit">
            <icon width="16" height="16" class="ds-schedule-stat-bar-icon">
                <IconTime />
            </icon>
            <span class="ds-schedule-stat-bar-label">Лимит часов:</span>
            <span class="ds-schedule-stat-bar-value" :class="{ 'text-darkred': !hoursValid }">{{ hoursLimit }} ({{ hoursDelta }})</span>
        </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import IconWarning from '../../ui/icons/IconWarning.vue'
import IconTime from '../../ui/icons/IconTime.vue'
import { computed } from 'vue'
import dayjs from 'dayjs'
import { useScheduleStore } from '@/stores/scheduleStore'
import { ownDepartmentShifts } from '@/utils/otherDepartmentShifts'

const store = useScheduleStore()
const shifts = computed(() => {
    let arr: any[] = []
    // Итоги подразделения: смены сотрудников в других подразделениях не учитываются (RD-176).
    store.schedules.map(item => arr.push(...ownDepartmentShifts(item.shifts, store.currentDepartment?.id)))
    return arr
})

const hlRule = computed(() => store.rules?.hours_limit_rule)
const hoursLimit = computed(() => hlRule.value?.hours_limit)
const hoursDelta = computed(() => (hlRule.value?.delta) ? Math.floor(hlRule.value?.delta) : '')
const hoursValid = computed(() => hlRule.value?.is_valid)

const moderate = computed(() => shifts.value.filter(item => item.violation?.general_status === 'moderate').length)
const warning = computed(() => shifts.value.filter(item => item.violation?.general_status === 'warning').length)
const mainShifts = computed(() => shifts.value.filter(item => !store.isExtraShift(item)))
const additionShifts = computed(() => shifts.value.filter(item => store.isExtraShift(item)))

const getPlanDurationHours = (shift: any) => {
    const rawDuration = shift?.duration
    if (rawDuration !== null && rawDuration !== undefined && rawDuration !== '') {
        const parsedDuration = Number(rawDuration)
        if (Number.isFinite(parsedDuration)) return parsedDuration
    }

    if (!shift?.plan_work_start_at || !shift?.plan_work_end_at) return 0

    const start = dayjs(shift.plan_work_start_at)
    let end = dayjs(shift.plan_work_end_at)

    if (!start.isValid() || !end.isValid()) return 0

    if (end.isSame(start) || end.isBefore(start)) {
        end = end.add(1, 'day')
    }

    return end.diff(start, 'minute') / 60
}

const formatHours = (value?: number | null) => {
    const numeric = Number(value)
    if (!Number.isFinite(numeric)) return '0:00'

    const sign = numeric < 0 ? '-' : ''
    const totalMinutes = Math.round(Math.abs(numeric) * 60)
    const hours = Math.floor(totalMinutes / 60)
    const minutes = totalMinutes % 60

    return `${sign}${hours}:${String(minutes).padStart(2, '0')}`
}

const planHours = computed(() => mainShifts.value.reduce((sum: number, item: any) => {
    return sum + getPlanDurationHours(item)
}, 0))
const additionHours = computed(() => additionShifts.value.reduce((sum: number, item: any) => {
    return sum + getPlanDurationHours(item)
}, 0))

const factHours = computed(() => shifts.value.reduce((sum: any, item: any) => {
    if (item.fact_work_start_at && item.fact_work_end_at) {
        const start = dayjs(item.fact_work_start_at)
        const end = dayjs(item.fact_work_end_at)
        return sum + end.diff(start, 'hour')
    }
    return sum
}, 0))

</script>
